import Image from 'next/image'

import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogOverlay,
  DialogContent,
  DialogHeader,
  DialogCloseButton,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'

type Props = Omit<DialogProps, 'children'>

export function DialogInfoPerilakuKerja(props: Props) {
  return (
    <Dialog {...props} size="lg">
      <DialogOverlay />

      <DialogContent className="!w-[1306px]">
        <DialogCloseButton />
        <DialogHeader title="Tentang Perilaku Kerja" />
        <div className="p-6 flex gap-16">
          <section className="flex flex-col gap-1 w-[443px]">
            <Text variant="heading-sm">
              Lebih dikenal dengan sebutan BerAKHLAK
            </Text>
            <Text>
              Perilaku Kerja terdiri atas 7 aspek yang lebih banyak dikenal
              dengan sebutan BerAKHLAK (Berorientasi Pelayanan, Akuntabel,
              Kompeten, Harmonis, Loyal, Adaptif, dan Kolaboratif).
            </Text>

            <div>
              <Image
                alt="BerAKHLAK"
                width={443}
                height={168}
                src="/images/kinerja/berakhlak.png"
              />
            </div>
            <a
              href={`${PENGELOLAAN_KINERJA_PS_PEGAWAI_PATH}/perencanaan/perilaku-kerja/panduan`}
              target="_blank"
              rel="noreferrer"
            >
              <Button color="white" size="md" className="!px-6 mt-7">
                Cek selengkapnya
                <Icon>chevron_right</Icon>
              </Button>
            </a>
          </section>
          <section className="flex-1 flex flex-col gap-8">
            <Text>
              Mari kita coba jabarkan aksi Perilaku Kerja di tiap tahapan!
            </Text>

            <div className="grid grid-cols-2 gap-x-8">
              <Text variant="heading-sm" className="col-span-2 mb-1">
                Tahap Perencanaan
              </Text>
              <div className="flex justify-between gap-6">
                <Image
                  alt=""
                  src="/images/kinerja/praktik-kinerja-info-1.png"
                  width={119}
                  height={86}
                />
                <Text className="flex-1">
                  Memilih 1 Indikator dan 1 Perwujudan (upaya mempraktikkan
                  indikator) untuk setiap aspek.
                </Text>
              </div>
              <div className="flex justify-between gap-6">
                <Image
                  alt=""
                  src="/images/img-clip-board-summary.png"
                  width={71}
                  height={76}
                />
                <Text className="flex-1">
                  Seluruh Indikator dan Perwujudan tetap harus dilakukan. Namun,
                  yang difokuskan cukup 1 saja.
                </Text>
              </div>
              <div className="flex flex-col gap-2 mt-8">
                <Text variant="heading-sm">Tahap Pelaksanaan</Text>

                <ul className="list-disc list-outside">
                  <li>
                    <Text>
                      Laksanakan sesuai Indikator dan Perwujudan yang dipilih
                    </Text>
                  </li>
                  <li>
                    <Text>
                      Tidak ada dokumen yang harus diisi atau rangkaian langkah
                      yang harus dilakukan
                    </Text>
                  </li>
                </ul>
              </div>
              <div className="flex flex-col gap-2 mt-8">
                <Text variant="heading-sm">Tahap Penilaian</Text>

                <Text>
                  Tim Kinerja akan menentukan rating Perilaku Kerja berdasarkan
                  hasil pemantauan peningkatan di masing-masing aspek. Pejabat
                  Penilai Kinerja lalu akan melakukan finalisasi saat Penetapan
                  Predikat Kinerja.
                </Text>
              </div>
            </div>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogInfoPerilakuKerja
